const swiper = new Swiper(".swiperFeaturedCollectionCarousel", {
	slidesPerView: 2,
	spaceBetween: 6,
	navigation: {
		nextEl: ".customFeaturedCC__next",
		prevEl: ".customFeaturedCC__prev",
	},
	pagination: {
		el: ".swiper-pagination",
    clickable: true
	},
	breakpoints: {
		640: {
			slidesPerView: 2,
			spaceBetween: 5,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 5,
		},
		1024: {
			slidesPerView: 5,
			spaceBetween: 8,
		},
	},
});
